import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../../nodeInstance";

export default function UpdateDetailsPopUp({
  list = [],
  PopUp,
  setPopUp,
  url,
  title,
  apiCall,
}) {
  const dispatch = useDispatch();
  const [date, setDate] = useState();
  const [dateEx, setDateEx] = useState();
  const dateSet = (date) => setDate(date);
  const dateSetExp = (date) => setDateEx(date);

  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("nodeToken");

  const update = async () => {
    var body = {
      employee_id: list,
      ajeer_issue_date: date,
      ajeer_expiry_date: dateEx,
    };
    setLoading(true);
    try {
      const response = await nodeinstance.post(url, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.status === 200) {
        dispatch(
          setAppError({
            msg: "Successfully uploaded.",
            color: "success",
          })
        );
        apiCall("");
        setPopUp(false);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      dispatch(
        setAppError({
          msg: error?.response?.data.error,
        })
      );
    }
  };

  const handleKeyDown = (event) => {
    event.preventDefault();
  };

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${PopUp ? "flex" : "hidden"
          }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <div className="w-full place-items-center">
            <div className="w-full flex flex-col gap-3 my-3 p-2">
              <div className="form-control w-full place-items-center">
                <h2 className="label place-items-center">{title}</h2>
                <h2 className="label place-items-center">
                  <span className="label-text">ISSUE Date</span>
                </h2>

                <input
                  type="date"
                  onKeyDown={handleKeyDown}
                  id="field2"
                  className={`input input-xl h-10 max-w-xl input-bordered focus:outline-none uppercase`}
                  required
                  onChange={(e) => dateSet(e.target.value)}
                />
                <h2 className="label place-items-center">
                  <span className="label-text">Expiry Date</span>
                </h2>

                <input
                  type="date"
                  onKeyDown={handleKeyDown}
                  id="field2"
                  className={`input input-xl h-10 max-w-xl input-bordered focus:outline-none uppercase`}
                  required
                  onChange={(e) => dateSetExp(e.target.value)}
                />
              </div>
              {/* <div className='flex flex-row'>
                                <h2 className="label place-items-center">
                                    TOTAL SELECT COUNT
                                </h2 >
                                <h2 className="label place-items-center font-bold">{length}</h2>
                            </div> */}

              <div
                className="flex gap-3 w-full justify-center"
                style={{ margin: 2 }}
              >
                <button
                  onClick={() => update()}
                  className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm" // Decreased padding and font size
                >
                  {" "}
                  <p>Submit</p>
                  {loading ? <CgSpinner className="animate-spin" /> : ""}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
